import React from 'react';
import PropTypes from 'prop-types';

import SeparatorLine from '@components/SeparatorLine';
import Switch from '@components/Switch';

import Container from '../components/Container';
import Content from '../components/Content';
import TextContainer from '../components/TextContainer';
import Caption from '../components/Caption';
import Text from '../components/Text';
import SeparatorContainer from '../components/SeparatorContainer';

function SwitchItem({
  text,
  caption,
  onToggle,
  selected,
  elementId,
  disabled,
  icon,
}) {
  return (
    <div id={elementId}>
      <Container>
        <Content>
          {icon}
          <TextContainer>
            <Text>{text}</Text>
            <Caption>{caption}</Caption>
          </TextContainer>
        </Content>
        <Switch
          toggleCheckbox={onToggle}
          disabled={disabled}
          isChecked={selected}
        />
      </Container>
      <SeparatorContainer>
        <SeparatorLine />
      </SeparatorContainer>
    </div>
  );
}

SwitchItem.propTypes = {
  text: PropTypes.string,
  caption: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  elementId: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
};

SwitchItem.defaultProps = {
  disabled: false,
};

export default SwitchItem;
